module.exports = __webpack_public_path__ + "static/media/augment_reality.77bb01ca.png";